import { render, staticRenderFns } from "./Nav-Bar.vue?vue&type=template&id=516fa36e&"
var script = {}
import style0 from "./Nav-Bar.vue?vue&type=style&index=0&id=516fa36e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports